<section>
  <div class="plan">
    <div class="d-flex flex-column align-items-start justify-content-between plan-premium">
      <div class="plan-header w-100">
        <div class="w-100 price-block">
          <h2><b [innerText]="planTiersMap[selectedPricePlan.tier]"></b></h2>
          <h2 class="price d-flex flex-row align-items-center gap-1">
            <b>{{ getPrice(selectedPricePlan) | currency: 'USD' : 'symbol' : '1.0-0' }}</b>
            <div class="save">
              <ng-container *ngIf="selectedPricePlan.plan_interval_length === 12">
                <tr-icon [icon]="icon.discount" [color]="iconColor.blue"></tr-icon>
                <p class="color-info">Save {{ calcSavePercentageForAnnual(selectedPricePlan.tier, selectedPricePlan.limit) }}%</p>
              </ng-container>
            </div>
          </h2>
          <p
            class="annual-description color-primary-text"
            *ngIf="selectedPricePlan?.plan_interval_length === 12"
          >
            Per month, billed annually (<strong>{{ selectedPricePlan.price / 100 | currency: 'USD' : 'symbol' : '1.0-0' }} per year</strong>)
          </p>
        </div>
        <div class="badge-popular" *ngIf="selectedPricePlan.tier === planTiers.business">
          <span class="badge badge-pill badge-success ml-2 ng-binding">Best value</span>
        </div>
      </div>

      <div class="mt-2 w-100 h-100 d-flex flex-column justify-content-between">
        <div class="d-flex flex-column plan-options">
          <p class="option" *ngIf="everythingInText" [innerText]="everythingInText"></p>
          <p class="option" *ngFor="let benefit of benefits[selectedPricePlan.tier]">
            <tr-icon [icon]="icon.check" [color]="iconColor.green"></tr-icon>
            {{ benefit }}
          </p>
        </div>

        <div class="plan-footer d-flex flex-column justify-content-center">
          <form [formGroup]="form">
            <div class="row form-group">
              <div class="mt-2 col-12">
                <select
                  class="form-control text-center"
                  name="limitSelector"
                  [hidden]="!currentPricePlan"
                  formControlName="selectedLimit"
                >
                  <option
                    *ngFor="let limit of limits"
                    [ngValue]="limit.value"
                    [hidden]="limit.hidden"
                  >{{ limit.value | number }} messages / mo</option>
                </select>
              </div>
            </div>
          </form>

          <div class="w-100 d-flex flex-row justify-content-center align-self-end">
            <button
              *ngIf="showSwitchPlansBtn"
              class="btn btn-success"
              [class.disabled]="blockActions || showReactivateBtn"
              (click)="locationIsOnTrial ? activate.emit(selectedPricePlan.plan_code) : switchPlans.emit(selectedPricePlan.plan_code)"
            >Switch Plans</button>

            <button
              *ngIf="!showSubscribeNowBtn && periodChanged"
              class="btn btn-success"
              [class.disabled]="blockActions || showReactivateBtn"
              (click)="switchPlans.emit(selectedPricePlan.plan_code)"
            >Switch to {{ planPeriod }}</button>

            <button
              *ngIf="showSubscribeNowBtn"
              class="btn btn-success"
              [class.disabled]="blockActions"
              (click)="activate.emit(selectedPricePlan.plan_code)"
            >Subscribe Now</button>

            <button
              *ngIf="showUpgradeBtn"
              class="btn btn-success"
              [class.disabled]="blockActions || showReactivateBtn"
              (click)="switchPlans.emit(selectedPricePlan.plan_code)"
            >Upgrade</button>

            <button
              *ngIf="showDowngradeBtn"
              class="btn btn-success"
              [class.disabled]="blockActions || showReactivateBtn"
              (click)="switchPlans.emit(selectedPricePlan.plan_code)"
            >Downgrade</button>

            <button
              class="btn btn-success"
              *ngIf="showReactivateBtn && showPauseAndCancelButtons"
              [class.disabled]="blockActions"
              [disabled]="!currentPricePlan.enabled && canceledSubscription || blockActions"
              (click)="reactivate.emit()"
            >Reactivate</button>

            <ng-container *ngIf="!showReactivateBtn && showPauseAndCancelButtons">
              <button
                class="btn btn-info"
                [class.disabled]="blockActions"
                [disabled]="blockActions"
                (click)="pause.emit()"
              >Pause</button>
              <button
                class="btn btn-danger ml-2"
                [class.disabled]="blockActions"
                [disabled]="blockActions"
                (click)="cancel.emit()"
              >Cancel</button>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
